export default "__VITE_ASSET__BSIkwdeH__"